import { render, staticRenderFns } from "./diemaker-details.component.vue?vue&type=template&id=73698832&scoped=true&"
import script from "./diemaker-details.component.ts?vue&type=script&lang=ts&"
export * from "./diemaker-details.component.ts?vue&type=script&lang=ts&"
import style0 from "./diemaker-details.component.scss?vue&type=style&index=0&id=73698832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73698832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
